import React, { FC } from 'react';
import styles from './Overlay.module.scss';
// import { Store } from '@/src/app/(root)/find-a-dealer/MapSection/Types/types';
// import Image from 'next/image';
import PhoneIcon from '../../../../../assets/icons/phone.svg';
import CurrentLocation from '../../../../../assets/icons/current-location-icon.svg';
import Direction from '../../../../../assets/icons/direction.svg';
import CloseIcon from '../../../../../assets/icons/close.svg';
// import Link from 'next/link';
import EmailIcon from '../../../../../assets/icons/email.svg';
import RegularOpeningHours from './RegularOpeningHours/RegularOpeningHours';
import { Image, Link } from '@sitecore-jss/sitecore-jss-react';

// type InfoSectionProps = {
//   selectedStore: Store;
//   onStart: () => void;
//   onContact: () => void;
// };

const InfoSectionMobile = ({ selectedStore, onStart, onContact, fields }) => (
  <div className={styles.infoSectionMobile}>
    <button className={styles.closeButton} onClick={onStart}>
      <img src={CloseIcon} alt="Close" />
    </button>
    <div className={styles.storeName}>
      <h3>
        <img src={CurrentLocation} alt="Location Icon" />{' '}
        {selectedStore?.storeName?.value || 'Unknown Store'}
      </h3>
    </div>
    <div className={styles.storeInfo}>
      {selectedStore?.phone?.value && (
        <p>
          <img src={PhoneIcon} alt="Phone Icon" />{' '}
          <a href={`tel:${selectedStore?.phone?.value}`}>{selectedStore?.phone?.value}</a>
        </p>
      )}
      {/* {selectedStore.email && (*/}
      {/*  <p>*/}
      {/*    <Image src={EmailIcon} alt='Email Icon' /> <a href={`mailto:${selectedStore.email}`}>{selectedStore.email}</a>*/}
      {/*  </p>*/}
      {/* )}*/}
      <p>
        <img src={Direction} alt="Direction Icon" />{' '}
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${selectedStore.location?.fields.lat?.value},${selectedStore.location?.fields.lng?.value}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* Get directions */}
          {fields?.directionText?.value || 'Get directions'}
        </a>
      </p>
      <div className={styles.address}>
        {selectedStore?.address?.value.split(',').map((part, index) => (
          <span key={index}>
            {part.trim()}
            {index < selectedStore.address?.value.split(',').length - 1 && <br />}
          </span>
        ))}
      </div>

      {selectedStore.distance?.value > 0 && (
        <p className={styles.distance}>
          ({(selectedStore.distance?.value * 0.000621371).toFixed(1)} miles)
        </p>
      )}
      <RegularOpeningHours content={selectedStore.hours?.value} />
    </div>
    {/* <button onClick={onContact} className={styles.contactButton}>*/}
    {/*  CONTACT*/}
    {/* </button>*/}
    <div className={styles.buttonContainer}>
      <a
        href={`${fields?.contactUrl?.value?.href || '/contact-us'}?dealer=${encodeURIComponent(
          selectedStore?.storeCode?.value || ''
        )}${fields?.contactUrl?.value?.querystring || ''}`}
        className={styles.contactButton}
      >
        {fields?.contactText?.value || 'CONTACT US'}
      </a>
    </div>
  </div>
);

export default InfoSectionMobile;
